import { Flex } from "playbook-ui";

const PbFlex = Flex;

export default PbFlex